import WithSearchControls from 'common/search-controls/with-search-controls';
import Component from './NotFound';
export const NotFound = Component;
export default WithSearchControls(NotFound);
